import { createApp } from 'vue';
import App from './App.vue';
import router from "./router";
import i18n from './i18n';
import store from "./state/store";
import { createPinia } from 'pinia'
import BootstrapVueNext from 'bootstrap-vue-next';

import vClickOutside from "click-outside-vue3";
import { vMaska } from "maska"

import VueFeather from 'vue-feather';

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'
import './assets/scss/app.scss';
import '@vueform/slider/themes/default.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

// FakeBackend authentication
// import { configureFakeBackend } from './helpers/fake-backend';
// configureFakeBackend();

// Niente librerie che le pagine non usano (Firebase, ApexCharts, AOS, Leaflet): erano
// nel bundle iniziale e si scaricavano a ogni apertura della dashboard.

const pinia = createPinia()


const toastOptions = {
    position: "bottom-right",
    transition: "Vue-Toastification__bounce",
    maxToasts: 5,
    newestOnTop: true
};

createApp(App)
    .use(pinia)
    .use(store)
    .use(router)
    .use(Toast, toastOptions)
    .use(BootstrapVueNext)
    .component(VueFeather.type, VueFeather)
    .directive("maska", vMaska)
    .use(i18n)
    .use(vClickOutside).mount('#app');